import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Carga de forma dinámica el script de Google Maps JavaScript API
 * usando la api key definida en los environments.
 */
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  /** Guarda la promesa de carga para evitar inyectar el script más de una vez */
  private loadPromise?: Promise<void>;

  /**
   * Inyecta el script de Google Maps una sola vez y resuelve cuando
   * la API invoca el callback global, señal de que `google.maps` está listo.
   * @returns Promesa que resuelve al completar la carga del script.
   */
  load(): Promise<void> {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      const callbackName = '__googleMapsApiReady';
      (window as any)[callbackName] = () => {
        delete (window as any)[callbackName];
        resolve();
      };

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.fe_google_maps_api_key}&libraries=marker&loading=async&callback=${callbackName}`;
      script.async = true;
      script.onerror = () =>
        reject(new Error('Error al cargar el script de Google Maps'));
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
